import { IEmployeeState } from '@/store/employee';
import { IEmployeeGetters } from './getters.types';
import {
  IEmployee,
  Employee,
  User,
  IUser,
  IEmployeeWorkSchedule,
  EmployeeWorkSchedule,
  HrDepartment,
  IHrDepartment
} from '@/models';

export const getters: IEmployeeGetters = {
  getEmployeeCount(state: IEmployeeState): number {
    return state.count;
  },

  getEmployees(state: IEmployeeState): IEmployee[] {
    return state.employees.map(data => new Employee(data));
  },

  getEmployeeById: (state: IEmployeeState) => (
    id: number
  ): IEmployee | undefined => {
    const data = state.employees.find(employee => employee.id === id);
    if (!data) {
      return undefined;
    }

    return new Employee(data);
  },

  getSalaryEmployeeUsers(state: IEmployeeState): IUser[] {
    return state.salaryEmployeeUsers.map(user => new User(user));
  },

  getSupervisorEmployees(state: IEmployeeState): IEmployee[] {
    return state.supervisorEmployees.map(data => new Employee(data));
  },

  getEmployeeWorkSchedule(
    state: IEmployeeState
  ): IEmployeeWorkSchedule | undefined {
    if (!state.employeeWorkSchedule) {
      return undefined;
    }
    return new EmployeeWorkSchedule(state.employeeWorkSchedule);
  },

  getEmployeeTeamDepartments(state: IEmployeeState): IHrDepartment[] {
    return state.employeeTeamDepartments.map(data => new HrDepartment(data));
  }
};
